import { Navigate, useLocation } from 'react-router-dom';

export const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  
  // Check if admin is authenticated
  const isAuthenticated = localStorage.getItem('admin_authenticated') === 'true';
  const sessionTime = localStorage.getItem('admin_session_time');
  
  // Check if session is still valid (24 hours)
  const isSessionValid = sessionTime && (Date.now() - parseInt(sessionTime)) < 24 * 60 * 60 * 1000;
  
  if (!isAuthenticated || !isSessionValid) {
    // Clear invalid session
    localStorage.removeItem('admin_authenticated');
    localStorage.removeItem('admin_session_time');
    
    // Redirect to login page
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};
